import axios from "axios";
import authHeader from "./auth-header";
const API_URL = "/api/linkslist/";
export default class LinksListService {
  list() {
    return axios.get(API_URL, { headers: authHeader() });
  }
  create(request) {
    return axios.post(API_URL + "create", request, {
      headers: authHeader(),
    });
  }

  delete(id) {
    return axios.post(API_URL + id + "/delete", null, {
      headers: authHeader(),
    });
  }
}
